import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const ControlsContainer = forwardRef(({ position, direction, children }, ref) => {
    const getPositionStyles = () => {
        const base = {
            position: 'fixed',
            display: 'flex',
            flexDirection: direction,
            gap: '10px',
            zIndex: 50,
        };
        switch (position) {
            case 'top-left':
                return Object.assign(Object.assign({}, base), { top: '10px', left: '10px' });
            case 'top-right':
                return Object.assign(Object.assign({}, base), { top: '10px', right: '10px' });
            case 'bottom-left':
                return Object.assign(Object.assign({}, base), { bottom: '10px', left: '10px' });
            case 'bottom-right':
                return Object.assign(Object.assign({}, base), { bottom: '10px', right: '10px' });
            default:
                return Object.assign(Object.assign({}, base), { bottom: '10px', right: '10px' }); // Дефолт: bottom-right
        }
    };
    return (_jsx("div", { ref: ref, style: getPositionStyles(), children: children }));
});
ControlsContainer.displayName = 'ControlsContainer';
export default ControlsContainer;
